/* KIVORA - Collection Cards JS */

document.addEventListener('DOMContentLoaded', function() {
  document.body.addEventListener('touchend', function(e) {
    var btn = e.target.closest('.kivo-cart-btn');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    kivoAddToCart(btn);
  }, { passive: false });

  document.body.addEventListener('click', function(e) {
    var btn = e.target.closest('.kivo-cart-btn');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    kivoAddToCart(btn);
  });
});

function kivoAddToCart(btn) {
  if (btn.dataset.loading) return;
  btn.dataset.loading = '1';
  var id = btn.getAttribute('data-variant-id');
  var txt = btn.querySelector('.kivo-btn-text');
  if (txt) txt.textContent = '...';
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: id, quantity: 1 })
  })
  .then(function(r) { return r.json(); })
  .then(function() {
    btn.classList.add('kivo-added');
    if (txt) txt.textContent = '✓';
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        document.querySelectorAll('[data-cart-count],.cart-count,.js-cart-count').forEach(function(el) {
          el.textContent = cart.item_count;
        });
      });
    setTimeout(function() {
      btn.classList.remove('kivo-added');
      if (txt) txt.textContent = 'In den Warenkorb';
      delete btn.dataset.loading;
    }, 2000);
  })
  .catch(function() {
    if (txt) txt.textContent = 'In den Warenkorb';
    delete btn.dataset.loading;
  });
}




